'use client';

import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material/Chip';

export type StatusPillColor = ChipProps['color'];

export interface StatusPillProps {
  status: string;
  colorMap?: Record<string, StatusPillColor>;
  variant?: 'outlined' | 'filled';
  size?: ChipProps['size'];
}

export function StatusPill({
  status,
  colorMap,
  variant = 'filled',
  size = 'small',
}: StatusPillProps) {
  const color = colorMap?.[status] ?? 'default';

  return <Chip label={status} color={color} variant={variant} size={size} />;
}

export default StatusPill;
